<template>
    <div :class="styleMain">
      <el-button :plain="!active" type="primary" size="mini" :icon="icon" @click="$emit('update')">{{ name }}</el-button>
    </div>
</template>

<script>
export default {
  name: 'SportFootballMatchStatusPeriodButton',
  props: {
    icon: {
      required: false,
      type: String
    },
    name: {
      required: false,
      type: String
    },
    active: Boolean
  },
  computed: {
    styleMain () {
      const style = ['sportFootballMatchStatusPeriodButton']
      if (this.name) {
        style.push('name')
      }
      return style
    }
  }
}
</script>

<style>
.sportFootballMatchStatusPeriodButton > button{
  width:35px;
  height:25px;
  border:none;
  box-sizing:border-box;
  padding:0;
  line-height:25px;
  font-size:18px;
}
.sportFootballMatchStatusPeriodButton.name > button{
  font-size:8px;
}
.sportFootballMatchStatusPeriodButton .el-button [class*="el-icon-"] + span{
  margin:0
}
</style>
